import { z } from 'zod';
import { DataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';

export const FullPayBenchmarkingCopilotDefinition = z
  .object({
    copilotType: z.literal('pay-benchmarking'),
    externalPayBenchmarkingReference: DataSetReference.optional(),
  })
  .describe('FullPayBenchmarkingCopilotDefinition');

export type FullPayBenchmarkingCopilotDefinition = z.infer<
  typeof FullPayBenchmarkingCopilotDefinition
>;

// We exclude any fields here that are data set references, since they cause a cache miss on the dependency due to the schema changing.
export const PayBenchmarkingCopilotDefinition =
  FullPayBenchmarkingCopilotDefinition.omit({
    externalPayBenchmarkingReference: true,
  }).describe('PayBenchmarkingCopilotDefinition');

export type PayBenchmarkingCopilotDefinition = z.infer<
  typeof PayBenchmarkingCopilotDefinition
>;
